export default "__VITE_ASSET__CHpG6vMK__"